/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * GrantType is the system's recognized groupings of features that a user can be entitled to. A
 * user's entitlement state will use the grant types assigned to entitlement events to dynamically
 * determine the features that user has access to.
 */
export type GrantType = (typeof GrantType)[keyof typeof GrantType];

export const GrantType = {
  STANDARD_SUBSCRIPTION: "STANDARD_SUBSCRIPTION",
  LIVE_VISIT_FOLLOW_UP: "LIVE_VISIT_FOLLOW_UP",
  STANDARD_VISIT_ACCESS: "STANDARD_VISIT_ACCESS",
  PARTNER_AFFILIATION: "PARTNER_AFFILIATION",
  ACCESS_PROGRAM: "ACCESS_PROGRAM",
  ACCOUNT_MERGE: "ACCOUNT_MERGE",
  ASYNC_REJECTION: "ASYNC_REJECTION",
  ONE_TIME_LIVE_CHAT_VISIT: "ONE_TIME_LIVE_CHAT_VISIT",
  ONE_TIME_VIDEO_VISIT: "ONE_TIME_VIDEO_VISIT",
  ONE_TIME_ASYNC_RX_VISIT: "ONE_TIME_ASYNC_RX_VISIT",
  ONE_TIME_ASYNC_DX_VISIT: "ONE_TIME_ASYNC_DX_VISIT",
  ONE_TIME_RX_RENEWAL_VISIT: "ONE_TIME_RX_RENEWAL_VISIT",
} as const;
